import React, { useCallback, useMemo } from "react";
import { RootState } from "@/store/redux/store";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import PlacemarkBusStation from "./PlacemarkBusStation";
import useBusstaitions from "../../../../../pages/Map/hooks/useBusstaitions";
import { openNavTab } from "../../../../../shared/components/NavTab/fuctionsControl";
import { IBusStation } from "../../../../../shared/types/busStaition";
import { setClickedStaitionByPlacemark } from "../../../../../pages/Map/store/mapScreenSlce";

const DEFAULT_SIZE: [number, number] = [15, 15];

const RenderPlacemarkBusStations: React.FC = () => {
  const dispatch = useDispatch();

  // точечные селекторы
  const busStaitionsOnMap = useSelector((s: RootState) => s.mapScreen.busStaitionsOnMap, shallowEqual);
  const transportTypes = useSelector((s: RootState) => s.mapScreen.transportTypes, shallowEqual);
  const busStation = useSelector((s: RootState) => s.mapScreen.busStation);
  const mapMode = useSelector((s: RootState) => s.mapScreen.mapMode);

  const { selectBusStaition } = useBusstaitions();

  // 1) фильтрация без setState
  const filteredStations = useMemo(() => {
    const list = busStaitionsOnMap ?? [];
    const types = transportTypes ?? [];

    const filtered =
      types.length > 0 ? list.filter((st) => types.includes(st.transport_type)) : list;

    // 2) dedupe стабильно (оставляем первый по idPrefix)
    const seen = new Set<string>();
    const unique: IBusStation[] = [];

    for (const st of filtered) {
      const key = (st.id ?? "").toString().split("_")[0]; // как у тебя логика active
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(st);
    }

    return unique;
  }, [busStaitionsOnMap, transportTypes]);

  // 3) стабильный callback
  const onClick = useCallback(
    (station: IBusStation) => {
      selectBusStaition(station, false);
      dispatch(setClickedStaitionByPlacemark(station));
      openNavTab();
    },
    [dispatch, selectBusStaition]
  );

  const activePrefix = useMemo(() => {
    return busStation?.id?.toString().split("_")[0] ?? null;
  }, [busStation?.id]);

  return (
    <>
      {filteredStations.map((station) => {
        const stationPrefix = station.id?.toString().split("_")[0];
        const isActive = !!activePrefix && activePrefix === stationPrefix;

        return (
          <PlacemarkBusStation
            key={stationPrefix ?? station.id} // ключ стабильный
            data={station}
            size={DEFAULT_SIZE}
            mapMode={mapMode}
            isActive={isActive}
            onClick={onClick}
          />
        );
      })}
    </>
  );
};

export default React.memo(RenderPlacemarkBusStations);